import { useId } from "react";

/** Illustration adapted from sources/access-denied-pixel/build.py. */
export type PixelGateItem = "lock" | "paper";

/** 오른쪽 장면: lock = 문 + 자물쇠(권한 없음·준비 중), paper = 쌓인 책·문서 더미(없는 페이지·오류) */
export function PixelGateScene({ item = "lock" }: { item?: PixelGateItem }) {
 const dotsId = useId();
 return (<svg viewBox="0 0 320 210" shapeRendering="crispEdges" aria-hidden="true">
<defs><pattern id={dotsId} width="16" height="16" patternUnits="userSpaceOnUse"><rect width="2" height="2" fill="var(--c-primary-100)"/></pattern></defs>
<path d="M44 44h16V28h192v16h24v120H44z" fill={`url(#${dotsId})`}/>
<path d="M64 180h200v4H64zM80 184h168v4H80z" className="floor"/>


{item === "lock" ? (<>
{/* 문 + 자물쇠 — 권한 없음·준비 중 */}
<path d="M156 44h64v4h8v132h-80V48h8z" fill="var(--c-primary-800)"/>
<path d="M156 52h64v124h-64z" fill="var(--c-primary-200)"/>
<path d="M164 60h48v108h-48z" fill="var(--c-primary-100)"/>
<path d="M168 64h40v4h-40zM168 68h4v96h-4z" fill="var(--c-surface)"/>
<path d="M204 116h8v8h-8z" fill="var(--c-primary-600)"/>
<path d="M144 176h88v4h-88z" fill="var(--c-primary-600)"/>
<path d="M184 89h12v4h4v15h-4V94h-12v14h-4V93h4z" fill="var(--c-primary-700)"/>
<path d="M176 102h28v23h-28z" fill="var(--c-warn-300)"/>
<path d="M176 102h28v4h-28z" fill="var(--c-warn-100)"/>
<path d="M188 110h4v8h-4z" fill="var(--c-primary-800)"/>
</>) : (<>
{/* 잔뜩 쌓인 책·문서 더미 — 없는 페이지·오류. 2px 격자 도트 */}
<path d="M144 176h88v4h-88z" fill="var(--c-primary-600)"/>
{/* 책 5권(아래→위, 폭·색 엇갈리게) */}
<path d="M150 164h76v12h-76z" fill="var(--c-primary-700)"/><path d="M154 168h68v2h-68zM154 172h40v2h-40z" fill="var(--c-primary-300)"/>
<path d="M156 152h66v12h-66z" fill="var(--c-warn-300)"/><path d="M160 156h58v2h-58zM160 160h30v2h-30z" fill="var(--c-warn-100)"/>
<path d="M148 142h70v10h-70z" fill="var(--c-primary-300)"/><path d="M152 146h62v2h-62z" fill="var(--c-primary-100)"/>
<path d="M158 130h66v12h-66z" fill="var(--c-primary-200)"/><path d="M162 134h58v2h-58zM162 138h24v2h-24z" fill="var(--c-primary-700)"/>
<path d="M152 120h60v10h-60z" fill="var(--c-accent)"/><path d="M156 124h52v2h-52z" fill="var(--c-surface)"/>
{/* 종이 더미(흰 장 3겹, 엇갈림) + 글줄 */}
<path d="M164 118h36v2h-36z" fill="var(--c-primary-700)"/>
<path d="M166 98h30v20h-30z" fill="var(--c-primary-700)"/><path d="M168 100h26v16h-26z" fill="var(--c-surface)"/>
<path d="M162 92h30v22h-30z" fill="var(--c-primary-700)"/><path d="M164 94h26v18h-26z" fill="var(--c-surface)"/>
<path d="M168 86h28v22h-28z" fill="var(--c-primary-700)"/><path d="M170 88h24v18h-24z" fill="var(--c-surface)"/>
<path d="M174 92h16v2h-16zM174 96h12v2h-12zM174 100h16v2h-16z" fill="var(--c-primary-300)"/>
{/* 옆에 기대 선 책 + 삐져나온 종이 */}
<path d="M224 128h10v48h-10z" fill="var(--c-primary-800)"/><path d="M226 132h6v2h-6zM226 136h6v26h-6z" fill="var(--c-primary-300)"/>
<path d="M212 102h22v2h2v2h2v18h-26z" fill="var(--c-primary-700)"/><path d="M214 104h18v2h2v2h2v14h-22z" fill="var(--c-surface)"/>
<path d="M234 104h2v4h-2z" fill="var(--c-primary-200)"/>
<path d="M218 110h12v2h-12zM218 114h8v2h-8z" fill="var(--c-primary-300)"/>
</>)}

<g className="pixel-dog"><g transform="translate(65 100) scale(4)"><rect x="4" y="0" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="0" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="0" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="0" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="1" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="5" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="1" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="16" y="1" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="2" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="5" y="2" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="6" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="8" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="11" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="2" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="15" y="2" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="16" y="2" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="2" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="8" y="3" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="3" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="11" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="16" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="17" y="3" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="2" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="4" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="4" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="4" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="4" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="4" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="4" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="4" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="16" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="17" y="4" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="2" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="5" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="4" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="6" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="5" width="1" height="1" fill="var(--c-surface)" />
<rect x="13" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="5" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="15" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="16" y="5" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="3" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="6" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="6" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="6" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="6" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="6" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="7" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="7" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="8" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="6" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="8" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="8" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="8" width="1" height="1" fill="var(--c-surface)" />
<rect x="13" y="8" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="8" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="9" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="9" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="9" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="9" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="9" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="9" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="9" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="9" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="9" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="10" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="10" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="10" width="1" height="1" fill="var(--c-danger-300)" />
<rect x="9" y="10" width="1" height="1" fill="var(--c-danger-300)" />
<rect x="10" y="10" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="10" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="10" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="11" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="11" width="1" height="1" fill="var(--c-info-300)" />
<rect x="8" y="11" width="1" height="1" fill="var(--c-info-300)" />
<rect x="9" y="11" width="1" height="1" fill="var(--c-info-300)" />
<rect x="10" y="11" width="1" height="1" fill="var(--c-info-300)" />
<rect x="11" y="11" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="12" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="12" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="12" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="12" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="12" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="12" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="12" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="12" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="13" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="13" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="13" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="7" y="13" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="13" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="13" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="13" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="13" width="1" height="1" fill="var(--c-slate-700)" />
<rect x="12" y="13" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="13" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="14" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="14" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="14" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="14" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="19" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="20" y="14" width="1" height="1" fill="var(--c-surface)" />
<rect x="4" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="18" y="15" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="19" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="20" y="15" width="1" height="1" fill="var(--c-surface)" />
<rect x="4" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="9" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="10" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="16" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="17" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="18" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="19" y="16" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="17" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="17" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="17" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="17" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="16" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="17" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="18" y="17" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="6" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="7" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="8" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="11" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="12" y="18" width="1" height="1" fill="var(--c-surface)" />
<rect x="13" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="16" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="17" y="18" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="4" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="5" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="6" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="7" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="8" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="9" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="10" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="11" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="12" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="13" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="14" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="15" y="19" width="1" height="1" fill="var(--c-slate-900)" />
<rect x="16" y="19" width="1" height="1" fill="var(--c-slate-900)" /></g></g>

<g className="bubble">
<path d="M90 66h32v4h4v22h-12v6h-4v-6H86V70h4z" fill="var(--c-primary-100)"/>
<path className="bubble-q" d="M103 73h2v2h-2zM105 73h2v2h-2zM107 73h2v2h-2zM101 75h2v2h-2zM109 75h2v2h-2zM109 77h2v2h-2zM105 79h2v2h-2zM107 79h2v2h-2zM105 81h2v2h-2zM105 85h2v2h-2z" fill="var(--c-primary-600)"/>
<path className="bubble-e" d="M105 73h2v2h-2zM105 75h2v2h-2zM105 77h2v2h-2zM105 79h2v2h-2zM105 81h2v2h-2zM105 85h2v2h-2z" fill="var(--c-primary-600)"/>
</g>


<path d="M246 157h4v14h-4zM238 151h8v8h-8zM250 145h8v12h-8z" fill="var(--c-accent)"/>
<path d="M238 166h20v4h-20zM242 170h12v10h-12z" fill="var(--c-primary-300)"/>
<path className="spark" d="M56 99h4v-4h4v4h4v4h-4v4h-4v-4h-4z" fill="var(--c-warn-300)"/>
<g className="float-tags" fontFamily="var(--font-mono, ui-monospace, monospace)" fontSize="11" fontWeight="700" fill="var(--c-primary-400)">
<text className="float-tag" x="42" y="68">Bori</text>
<text className="float-tag second" x="112" y="56">보리</text>
</g>
<path className="spark second" d="M246 65h4v-5h4v5h4v4h-4v5h-4v-5h-4z" fill="var(--c-primary-300)"/>
<path d="M72 153h4v4h-4zM260 115h4v4h-4z" fill="var(--c-primary-200)"/>
</svg>);
}
